export enum PhotoType {
    INSPECTION = 'inspection',
    ANOMALIE = 'anomalie',
    POINT_AUDIT = 'pointAudit',
    ANOMALIE_AUDIT = 'anomalieAudit',
}
